import React from 'react';
import { formatNumber, formatPrice } from '../utils/pricingUtils';
import { logger } from '../../../utils/logger';

/**
 * Component for configuring custom pricing plan details
 */
const CustomPlanConfig = ({
  agentCount,
  queryCount,
  documentCount,
  customPrice,
  formValidation,
  minAgents,
  maxAgents,
  minQueries,
  maxQueries,
  minDocuments,
  maxDocuments,
  onAgentChange,
  onQueryChange,
  onDocumentChange,
  onClose
}) => {
  return (
    <>
      <div 
        className="custom-config-overlay" 
        onClick={() => {
          logger.debug("Overlay clicked, closing modal");
          onClose();
        }}
      ></div>
      <div className="custom-config">
        <button 
          className="custom-config-close" 
          onClick={() => {
            logger.debug("X button clicked, closing modal");
            onClose();
          }}
        >×</button>
        <h2>Customize Your Plan</h2>
        <p>Adjust the sliders below to create your perfect plan.</p>
        
        <div className="slider-container">
          <label>
            Number of Agents: <strong>{agentCount}</strong>
            <input 
              type="range" 
              min={minAgents} 
              max={maxAgents} 
              value={agentCount} 
              onChange={onAgentChange} 
            />
            <div className="slider-labels">
              <span>{minAgents}</span>
              <span>50</span>
              <span>{maxAgents}</span>
            </div>
          </label>
          {formValidation.agentError && (
            <div className="validation-error">{formValidation.agentError}</div>
          )}
        </div>
        
        <div className="slider-container">
          <label>
            Monthly Queries: <strong>{formatNumber(queryCount)}</strong>
            <input 
              type="range" 
              min={minQueries} 
              max={maxQueries} 
              step="50" 
              value={queryCount} 
              onChange={onQueryChange} 
            />
            <div className="slider-labels">
              <span>{minQueries}</span>
              <span>5,000</span>
              <span>{formatNumber(maxQueries)}</span>
            </div>
          </label>
          {formValidation.queryError && (
            <div className="validation-error">{formValidation.queryError}</div>
          )}
        </div>
        
        <div className="slider-container">
          <label>
            Documents: <strong>{formatNumber(documentCount)}</strong>
            <input 
              type="range" 
              min={minDocuments} 
              max={maxDocuments} 
              step="10" 
              value={documentCount} 
              onChange={onDocumentChange} 
            />
            <div className="slider-labels">
              <span>{minDocuments}</span>
              <span>25,000</span>
              <span>{formatNumber(maxDocuments)}</span>
            </div>
          </label>
          {formValidation.documentError && (
            <div className="validation-error">{formValidation.documentError}</div>
          )}
        </div>
        
        <div className="price-summary">
          <div className="price-label">Monthly Price:</div>
          <div className="price-value">{formatPrice(customPrice)}</div>
        </div>
        
        <div className="modal-close-hint">
          <small>Click outside to apply changes</small>
        </div>
      </div>
    </>
  );
};

export default CustomPlanConfig; 